import { render, staticRenderFns } from "./komoditi.vue?vue&type=template&id=a2c1d528&"
import script from "./komoditi.vue?vue&type=script&lang=js&"
export * from "./komoditi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports